
/**
 * For IE 11. Core-js doesn't seem to have one.
 */
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this)
        }
    }
}
